module.exports = __webpack_public_path__ + "static/media/linkedin.910157c9.png";